import { IntegrationShell } from "../../common/Shell";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import CloudonixForm from "./CloudonixForm";
import { useLayoutEffect } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function CloudonixIntegration() {
  const {
    projectId,
    thirdpartyData,
    updateThirdpartyData,
    company,
    isThirdPartyLoading,
    isViewOnly
  } = useOutletContext();

  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (
      company &&
      !company.thirdPartyIntegrationVisibility.showCloudonixIntegration
    ) {
      navigate("/not-found", { replace: true });
    }
  }, [company]);

  if (!company) {
    return null;
  }

  if (
    company &&
    company?.thirdPartyIntegrationVisibility &&
    !company.thirdPartyIntegrationVisibility.showCloudonixIntegration
  ) {
    return (
      <Navigate
        to="not-found"
        replace
      />
    );
  }

  if (isThirdPartyLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    );
  }

  return (
    <IntegrationShell>
      <CloudonixForm
        workspaceId={projectId}
        cloudonixSettings={thirdpartyData?.telephonySettings.cloudonixSettings}
        updateCloudonixSettings={updateThirdpartyData}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
